import ConstructionReports from './ConstructionReports';
import DayPlanReport from './DayPlanReport';

const ReportRoutes = [
  {
    path: '/reports/construction',
    element: <ConstructionReports />,
  },
  {
    path: '/reports/day-plan',
    element: <DayPlanReport />,
  },
];

export default ReportRoutes;
